import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

const LandingFooter: React.FC = () => (
  <footer className={css(styles.footer)}>
    <div className={css(styles.container2)}>
      <div className={css(styles.footerGrid)}>
        <div className={css(styles.footerSection)}>
          <h3 className={css(styles.footerTitle)}>Company</h3>
          <ul className={css(styles.footerLinks)}>
            <li>
              <a href="/about" className={css(styles.footerLink)}>
                About DayDaCo
              </a>
            </li>
            <li>
              <a
                href="/collaborative-governance"
                className={css(styles.footerLink)}
              >
                Collaborative Governance
              </a>
            </li>
            <li>
              <a href="/digital-ecosystem" className={css(styles.footerLink)}>
                Digital Ecosystem
              </a>
            </li>
            <li>
              <a href="/news-press" className={css(styles.footerLink)}>
                News and Press
              </a>
            </li>
            <li>
              <a href="/careers" className={css(styles.footerLink)}>
                Careers
              </a>
            </li>
          </ul>
        </div>
        <div className={css(styles.footerSection)}>
          <h3 className={css(styles.footerTitle)}>Community</h3>
          <ul className={css(styles.footerLinks)}>
            <li>
              <a href="/community" className={css(styles.footerLink)}>
                Community Overview
              </a>
            </li>
            <li>
              <a
                href="/community/sustainability"
                className={css(styles.footerLink)}
              >
                Sustainability
              </a>
            </li>
            <li>
              <a
                href="/community/third-party-engagements"
                className={css(styles.footerLink)}
              >
                Third-Party Engagements
              </a>
            </li>
          </ul>
        </div>
        <div className={css(styles.footerSection)}>
          <h3 className={css(styles.footerTitle)}>Support</h3>
          <ul className={css(styles.footerLinks)}>
            <li>
              <span className={css(styles.footerLinkDisabled)}>
                Help Center
              </span>
            </li>
            <li>
              <a href="/contact" className={css(styles.footerLink)}>
                Contact Us
              </a>
            </li>
            <li>
              <span className={css(styles.footerLinkDisabled)}>Tutorials</span>
            </li>
          </ul>
        </div>
        <div className={css(styles.footerSection)}>
          <h3 className={css(styles.footerTitle)}>Legal</h3>
          <ul className={css(styles.footerLinks)}>
            <li>
              <span className={css(styles.footerLinkDisabled)}>
                Terms of Service
              </span>
            </li>
            <li>
              <span className={css(styles.footerLinkDisabled)}>
                California Privacy Policy
              </span>
            </li>
            <li>
              <span className={css(styles.footerLinkDisabled)}>
                Cookie Policy
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className={css(styles.footerBottom)}>
        <div className={css(styles.footerBottomContent)}>
          <div className={css(styles.footerBottomLeft)}>
            <img
              src="/dd_logo.png"
              alt="DayDaCo Logo"
              className={css(styles.logo)}
            />
            <p className={css(styles.footerCopyright)}>
              © 2025 DayDaCo. All rights reserved.
            </p>
          </div>
          <div className={css(styles.footerSocial)}>
            <span
              className={css(
                styles.footerSocialLink,
                styles.footerSocialLinkDisabled,
              )}
            >
              <i className="fab fa-facebook-f" />
            </span>
            <span
              className={css(
                styles.footerSocialLink,
                styles.footerSocialLinkDisabled,
              )}
            >
              <i className="fab fa-twitter" />
            </span>
            <span
              className={css(
                styles.footerSocialLink,
                styles.footerSocialLinkDisabled,
              )}
            >
              <i className="fab fa-linkedin-in" />
            </span>
            <span
              className={css(
                styles.footerSocialLink,
                styles.footerSocialLinkDisabled,
              )}
            >
              <i className="fab fa-instagram" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
)

const styles = StyleSheet.create({
  footer: {
    color: '#102E65',
    padding: '48px',
  },
  container2: {
    maxWidth: '1600px',
    margin: '0 auto',
  },
  footerGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '32px',
    '@media (min-width: 768px)': {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
  },
  footerSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  footerTitle: {
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: '16px',
  },
  footerLinks: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  footerLink: {
    color: '#4B5563',
    textDecoration: 'none',
    ':hover': {
      color: '#102E65',
    },
    fontSize: '14px',
  },
  footerLinkDisabled: {
    color: '#4B5563',
    fontSize: '14px',
    cursor: 'default',
  },
  footerBottom: {
    marginTop: '32px',
    paddingTop: '32px',
  },
  footerBottomContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    '@media (min-width: 768px)': {
      flexDirection: 'row',
    },
  },
  footerBottomLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  logo: {
    height: '32px',
  },
  footerCopyright: {
    color: '#9ca3af',
    fontSize: '14px',
  },
  footerSocial: {
    display: 'flex',
    gap: '16px',
    marginTop: '16px',
    '@media (min-width: 768px)': {
      marginTop: '0',
    },
  },
  footerSocialLink: {
    color: '#9ca3af',
    textDecoration: 'none',
    ':hover': {
      color: '#ffffff',
    },
  },
  footerSocialLinkDisabled: {
    cursor: 'default',
    ':hover': {
      color: '#9ca3af',
    },
  },
})

export default LandingFooter
